import React from 'react'

import H from "./H"

// convenienve wrapper for H
export default class H1 extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      text: props.text,
      color: props.color,
      textSize: props.textSize,
      className: props.className,
      textAlign: props.textAlign,
      editable: props.editable
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  render(){
    let {
      text,
      color,
      textSize,
      className,
      textAlign,
      editable
    } = this.state

    return (
      <H
        level={ 1 }
        className={className + ' pre '}
        text={ text }
        textSize={ textSize }
        color={ color }
        editable={ editable }
        textAlign={ textAlign }
        onUpdated={text => this.props.onUpdated(text)}
      />
    )
  }
}
